/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Word_Back_TitleInputs */

const en_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Word Up`)
};

const fr_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler le Mot en Haut`)
};

const de_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort nach oben verschieben`)
};

const it_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta parola su`)
};

const ru_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвиг слова вверх`)
};

const es_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar palabra hacia arriba`)
};

const zh_cn2_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向上移动单词`)
};

const ja_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を上にシフト`)
};

const hi_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द को ऊपर ले जाएं`)
};

const pt_pt2_shift_word_back_title = /** @type {(inputs: Shift_Word_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Word Up`)
};

/**
* | output |
* | --- |
* | "Shift Word Up" |
*
* @param {Shift_Word_Back_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_word_back_title = /** @type {((inputs?: Shift_Word_Back_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Word_Back_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shift_word_back_title(inputs)
	if (locale === "de") return de_shift_word_back_title(inputs)
	if (locale === "it") return it_shift_word_back_title(inputs)
	if (locale === "ru") return ru_shift_word_back_title(inputs)
	if (locale === "es") return es_shift_word_back_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shift_word_back_title(inputs)
	if (locale === "ja") return ja_shift_word_back_title(inputs)
	if (locale === "hi") return hi_shift_word_back_title(inputs)
	if (locale === "pt-PT") return pt_pt2_shift_word_back_title(inputs)
	return en_shift_word_back_title(inputs)
});